import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import '../css/notFoundPage.css';

const NotFoundPage: FunctionComponent = () => {
  const navigate = useNavigate();
  return (
    <div className='not-found-page-container'>
      <div className='vdr-404-inner'>
        <span className='vdr-eyebrow vdr-eyebrow--bar vdr-eyebrow--on-dark vdr-404-kicker'>
          Error
        </span>
        <p className='vdr-404-code'>404</p>
        <h1 className='vdr-404-title'>Página no encontrada</h1>
        <Button
          className='vdr-404-btn'
          onClick={() => navigate('/')}
          variant='contained'
          color='primary'
          sx={{ height: 52, px: 3.25, gap: 1.25, fontSize: 16 }}>
          <KeyboardReturnIcon sx={{ fontSize: 20 }} />
          Volver al inicio
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
